module.exports = __webpack_public_path__ + "img/supported_cards.0136b910.png";